import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../../providers/ortak';


@Component({
  selector: 'page-kasa-virmanislemi',
  templateUrl: 'kasa-virmanislemi.html',
})
export class KasaVirmanislemiPage {
  giris: any = { ID: -1, KasaID: "", IslemTuru: 12, Sign: 1, Tutar: "", SlsMan: "", Text: "Virman İşlemi" };
  cikis: any = { ID: -1, KasaID: "", IslemTuru: 12, Sign: 0, Tutar: "", SlsMan: "", Text: "Virman İşlemi" };
  kasalistesi = [];
  constructor(public navCtrl: NavController,
    public bllortak: BllOrtak,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
      this.giris.SlsMan=this.ortak.storagePersonelGetir.Name;
      this.cikis.SlsMan=this.giris.SlsMan;
  }

  ionViewDidLoad() {
   this.KasalariGetir();
  }
  KasalariGetir() {
    this.bllortak.islemWithoutPost("KasaList", "", false).then(a => {
      var sonuc = <any>a;
      this.kasalistesi = sonuc.SonucObject;
    })
  }
  Kaydet()
  {
    this.cikis.Tutar=this.giris.Tutar;
    var formdata=new FormData();
    formdata.append("kasacikis",JSON.stringify(this.cikis));
    formdata.append("kasagiris",JSON.stringify(this.giris));
    this.bllortak.islem(formdata,"KasaVirman","",true).then(a=>{
      var sonuc=<any>a;
      if(sonuc.Sonuc==1)
      {
        this.ortak.showBasicAlert("Başarılı","Virman işlemi başarılı bir şekilde kaydedildi");
        this.viewCtrl.dismiss();
      }
    })
  }
  kapat()
  {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/KasaIslemleri/kasa-virmanislemi/kasa-virmanislemi.ts